import { NumberInput, maxValue, minValue, required } from "react-admin";
import { integerValidator } from "utils/validations";
import GridItem from "./GridItem";

const MAX_COURSE_YEAR = 12;

const CourseYearInput = ({ source = "year", label = "Курс", md = 6 }) => (
  <GridItem md={md}>
    <NumberInput
      source={source}
      label={label}
      fullWidth
      min={1}
      max={MAX_COURSE_YEAR}
      step={1}
      validate={[
        required("Полето е задължително."),
        minValue(1, "Минималната стойност е 1."),
        maxValue(MAX_COURSE_YEAR, `Максималната стойност е ${MAX_COURSE_YEAR}.`),
        integerValidator,
      ]}
      onWheel={e => e.target.blur()}
    />
  </GridItem>
);

export default CourseYearInput;
